import React from "react";

export const getUniformOptionWidthClass = (options = []) => {
  const longestOptionLength = options.reduce((maxLength, option) => {
    if (typeof option !== "string") {
      return maxLength;
    }

    return Math.max(maxLength, option.replaceAll("_", ",").length);
  }, 0);

  if (longestOptionLength > 28) {
    return "max-w-[20rem]";
  }

  if (longestOptionLength > 18) {
    return "max-w-[17rem]";
  }

  return "max-w-[14rem]";
};

const CustomOptionButton = ({
  text,
  index,
  selectedIdx,
  onClick,
  fontSize,
  optionWidthClass,
}) => {
  const normalizedText =
    typeof text === "string" ? text.replaceAll("_", ",") : "";
  const isLink =
    typeof text === "string" &&
    (text.startsWith("https://") || text.startsWith("http://"));

  const isSelected = Array.isArray(selectedIdx)
    ? selectedIdx.includes(index)
    : selectedIdx === index;

  const widthClasses = isLink
    ? "max-w-[8rem] sm:max-w-[10rem] md:max-w-[12rem]"
    : optionWidthClass || "max-w-[14rem]";
  const baseClasses =
    "flex h-[4rem] w-full items-center justify-center overflow-hidden rounded-3xl transition-all duration-300 cursor-pointer font-mali font-bold sm:h-[4.25rem]";

  // ✅ Handle fontSize prop or fall back to dynamic text size based on length
  const getTextSizeStyle = () => {
    if (fontSize) {
      return { fontSize: fontSize };
    }
    return {};
  };

  const getTextSizeClasses = () => {
    if (fontSize) {
      return "";
    }
    return normalizedText.length > 19
      ? "text-sm sm:text-base md:text-lg"
      : "text-base sm:text-lg md:text-xl";
  };

  const stateClasses = isSelected
    ? "bg-blue-300 text-white"
    : "hover:bg-blue-100 bg-gray-100";
  const textClasses = `${getTextSizeClasses()} w-full text-center leading-snug`;

  const imageClasses =
    "max-h-10 max-w-full object-contain sm:max-h-12 md:max-h-16";

  return (
    <div
      className={`flex w-full min-w-0 shrink-0 justify-center ${widthClasses}`}
    >
      {isLink ? (
        <div
          key={index}
          onClick={() => onClick(index)}
          className={`${baseClasses} px-4 py-3 ${stateClasses}`}
        >
          <img alt="option" src={text} className={imageClasses} />
        </div>
      ) : (
        <div
          key={index}
          onClick={() => onClick(index)}
          className={`${baseClasses} px-4 py-3 ${textClasses} ${stateClasses}`}
          style={getTextSizeStyle()}
          title={normalizedText}
        >
          <span
            className="block w-full overflow-hidden"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            {normalizedText}
          </span>
        </div>
      )}
    </div>
  );
};

export default CustomOptionButton;
